import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '@core/notification/notification.service';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: [],
  animations: [
    trigger('showNotification', [
      state('*', style({
      })),
      state('false', style({
        transform: 'translate3d(0, -80px, 0)'
      })),
      transition('void <=> *', animate('250ms ease-in-out')),
    ])
  ]
})
export class NotificationComponent implements OnInit {

  @Input()
  public type: string = '';

  @Input()
  public message: string = '';

  @Input()
  public componentRef;

  public active: boolean = true;

  constructor() {}

  ngOnInit() {
    setTimeout(() => {
      this.active = false;
      setTimeout(() => {
        this.close();
      }, 500);
    }, 2000);
  }

  isSuccess() {
    return this.type === 'success';
  }

  isAlert() {
    return this.type === 'alert';
  }

  close() {
    this.active = false;
    this.componentRef.destroy();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/notification/notification.component.ts